import { NSARouterMakerResult } from 'namirasoft-account-react';
import { LogLayout } from '../LogLayout';
import { LogEntities } from '../LogEntities';
import { LogProps } from '../LogProps';
import { NSCCostChart } from 'namirasoft-cost-react';

interface LogGroupViewPageProps extends NSARouterMakerResult, LogProps
{ }

function LogGroupViewPage(props: LogGroupViewPageProps) 
{
	return (
		<LogLayout {...props}
			action={{
				description: "This section displays the contents and details of a log group in a read-only view.",
			}}
			pages={{
				entity: LogEntities.log_group(props),
				view: {
					ui: {
						tab_page_view: {
							tabs: {
								extra: {
									after_history: [
										NSCCostChart.getTab(props)
									]
								}
							}
						}
					}
				}
			}}
		>
			<></>
		</LogLayout >
	);
}

export default LogGroupViewPage;